import React, { Component } from 'react';
import { Nav, NavItem } from 'reactstrap';
import { Link } from "react-router-dom";
import './aside.scss';
import { ROLE_ADMIN, ROLE_ANALYST } from '../../constants';
class Aside extends Component {
    constructor(props) {
        super(props);
        this.state = {
            corporateCollapsed: true,
            caseCollapsed: true,
        };
    }
    disableSearchBox= (e)=>{
        this.props.handleSearchBox(e.target.textContent)
    }
    render() {
        const location = this.props.history.location;
        const scope = this.props.userDetails.scopes[0]
        return (
            <aside className="app-aside app-aside-corporate" style={{ '--background': this.props.corporateColor }}>
                <Nav vertical>
                    <NavItem>
                        <Link className={(location.pathname).split('/')[1] === "home" ? "nav-link active" : "nav-link"} onClick={this.disableSearchBox} to={`/home`}>HOME</Link>
                    </NavItem>
                    <NavItem>
                        <Link className={(location.pathname).split('/')[1] === "dashboard" ? "nav-link active" : "nav-link"} onClick={this.props.showHideMenu} to={`/dashboard/${'Geography'}`}>DASHBOARD</Link>
                    </NavItem>
                    <NavItem>
                        <Link className={(location.pathname).split('/')[1] === "my-portfolio" ? "nav-link active" : "nav-link"} onClick={this.props.showHideMenu} to={`/my-portfolio/${1}`}>MY PORTFOLIO</Link>
                    </NavItem>
                    <NavItem>
                        <Link className={!this.state.corporateCollapsed ? "nav-link active" : "nav-link"} onClick={(e) => {
                            e.preventDefault();
                            this.setState((prevState) => ({ corporateCollapsed: !prevState.corporateCollapsed }));
                            return false;
                            }} to="">USAGE STATS<i className={!this.state.corporateCollapsed ? "icon-arrow-up" : "icon-arrow-down"}></i>
                        </Link>
                            <Nav className={this.state.corporateCollapsed ? 'collapse' : ''} vertical>
                                {/*<NavItem>
                                    <Link className={!this.state.corporateCollapsed ? "nav-link text-white" : "nav-link"} to="/usage-stats/dashboard">Dashboard</Link>
                                </NavItem>*/}
                                <NavItem>
                                    <Link className={!this.state.corporateCollapsed ? "nav-link text-white" : "nav-link"} to="/usage-stats/reports">Reports</Link>
                                </NavItem>
                            </Nav>
                    </NavItem>

                    <NavItem>
                        <Link className={location.pathname === "/monitoring/dashboard" ? "nav-link active" : "nav-link"} onClick={this.props.showHideMenu} to="/monitoring/dashboard">Monitoring</Link>
                    </NavItem>

                    <NavItem>
                        <Link className={!this.state.caseCollapsed ? "nav-link active" : "nav-link"} onClick={(e) => {
                            e.preventDefault();
                            this.setState((prevState) => ({ caseCollapsed: !prevState.caseCollapsed }));
                            return false;
                        }} to="">EWS Dashboard<i
                            className={!this.state.caseCollapsed ? "icon-arrow-up" : "icon-arrow-down"}></i>
                        </Link>
                        <Nav className={this.state.caseCollapsed ? 'collapse' : ''} vertical>
                            <NavItem>
                                <Link
                                    className={location.pathname === "/ews/ewsChart" ? "nav-link text-white" : "nav-link"}
                                    to="/ews/ewsChart">Show Graph
                                </Link>
                            </NavItem>
                            <NavItem>
                                <Link
                                    className={location.pathname === "/ews/ewsReport" ? "nav-link text-white" : "nav-link"}
                                    to="/ews/ewsReport">EWS Report
                                </Link>
                            </NavItem>
                        </Nav>
                    </NavItem>
                    <NavItem>
                        <Link className={location.pathname === "/bulk/report/request" ? "nav-link active" : "nav-link"} onClick={this.props.showHideMenu} to="/bulk/report/request">Bulk Report Request</Link>
                    </NavItem>
                    {/*commenting mis order data flow for corporates for now
                    <NavItem>
                        <Link className={location.pathname === "/mis/order-data" ? "nav-link active" : "nav-link"} onClick={this.props.showHideMenu} to="/mis/order-data">Order Data</Link>
                </NavItem>*/}
                </Nav>
            </aside>
        );
    }
}

export default Aside;
